import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const TableBox = styled.table`
  width: 100%;
  border-spacing: 0 2px;
  thead {
    background-color: ${Variables.colors.complementary};
    top: 0;
    z-index: 999;
    th {
    	height: 42px;
      top: 0;
      z-index: 999;
      background-color: ${Variables.colors.complementary};
      border-bottom: solid 1px ${Variables.colors.complementary_500};
      padding: 11px 26px;
      color: ${Variables.colors.complementary_700};
      font-size: ${Variables.font_sizes.x_medium};
      font-weight: ${Variables.font_weight.regular};
      line-height: 1.57;
      text-align: right;
    }
  }
  tbody {
    tr {
      background-color: ${Variables.colors.complementary};
      td {
        height: 42px;
        border-bottom: solid 1px ${Variables.colors.complementary_400};
        padding: 11px 26px;
        font-family: Number, sans-serif;
        font-size: ${Variables.font_sizes.x_medium};
        font-weight: ${Variables.font_weight.regular};
        line-height: 1.57;
        text-align: right;
        color: ${Variables.colors.complementary_900};
        &.error{
          color: ${Variables.colors.red_500};
        }
        .cell-label {
          color: ${Variables.colors.complementary_600} !important;
          font-size: ${Variables.font_sizes.x_small} !important;
        }
      }
      &:last-child {
        td {
          border-bottom: solid 1px ${Variables.colors.complementary_600};
        }
      }
      .row-controls-button {
        width: 5px !important;
        position: relative;
        padding: 0 !important;
        background-color: inherit;
      }
      .hidden-td {
        display: flex;
      	padding-right: 13px;
      	min-height: 43px;
      	height: 100%;      	
				align-items: center;
				justify-content: center;
				position: absolute;
				left: 4px;
				top: 0;
      	i {
          display: none;      		
      		align-items: center;
      		justify-content: center;
      		width: 40px;
      		height: 40px;
      		background-color: transparent;
      		border-radius: 50%;
      		cursor: pointer;
          &.active {
            display: flex;
            &.green {
              color: ${Variables.colors.green_800};
              position: absolute;
              left: 40px;
            }
            &.yellow {
              color: ${Variables.colors.yellow_500};
              position: absolute;
              left: 40px;
            }
            &.red {
              color: ${Variables.colors.red_600};
            }
          }
          &:before {
      			margin-left: 0;
      			font-size: 16px;            
          }
          &.icon mapsa-trash:before, &.red:before {
      			color: ${Variables.colors.red_600};
      		}
          &.mapsa-trash{
            &:hover{
                color: ${Variables.colors.red_600};
                background-color: ${Variables.colors.red_100};
            }
          }
          &.red{
            &:hover{
              color: ${Variables.colors.red_600};
              background-color: ${Variables.colors.red_100};
            }
          }
          &.green:hover {
            color: ${Variables.colors.green_800};            
            background-color: ${Variables.colors.green_100};
          }
          &.yellow:hover {
            color: ${Variables.colors.yellow_500};            
            background-color: ${Variables.colors.yellow_100};
          }
         
      	}
      }
      &:hover {        
      	-webkit-box-shadow: 0 0 6px 0 #CCCCCC;
				-moz-box-shadow: 0 0 6px 0 #CCCCCC;
				box-shadow: 0 0 6px 0 #CCCCCC;
      	.hidden-td i {
      		display: flex;
      	}
      }
    }
  }
`;
